module.exports = __webpack_public_path__ + "static/media/stockuser.ab48a209.png";